var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-wrap"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"text"},[_vm._t("title")],2),_vm._t("status")],2),_vm._t("content"),_c('div',{staticClass:"button pointer",on:{"click":function($event){return _vm.handleGoPage(_vm.id)}}},[_vm._v("活动详情")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }